export type TokenLoginEntry = Readonly<{
  memberId: string;
  sanitizedPath: string;
}>;

export function parseTokenLoginLocation(href: string): TokenLoginEntry {
  const url = new URL(href);
  const memberId =
    url.searchParams.get("memberId")?.trim() ||
    url.searchParams.get("memberid")?.trim() ||
    "";
  url.searchParams.delete("memberId");
  url.searchParams.delete("memberid");

  return {
    memberId,
    sanitizedPath: `${url.pathname}${url.search}${url.hash}`,
  };
}

export function consumeTokenLoginMemberId(): string {
  const bootstrapMemberId =
    document.documentElement.dataset.tokenLoginMemberId?.trim() ?? "";
  delete document.documentElement.dataset.tokenLoginMemberId;
  const { memberId, sanitizedPath } = parseTokenLoginLocation(
    window.location.href
  );
  window.history.replaceState(window.history.state, "", sanitizedPath);
  return bootstrapMemberId || memberId;
}
